import { createSlice } from '@reduxjs/toolkit';
import { initialFonts } from '../../constants/agents/allFonts';

const fontsSlice = createSlice({
  name: 'fonts',
  initialState: {
    list: initialFonts,
  },
  reducers: {
    addFont: (state, action) => {
      const addedFont = action.payload?.trim?.() || '';
      if (!addedFont) return;

      const alreadyExists = state.list.some(
        font => font.value.toLowerCase() === addedFont.toLowerCase()
      );

      if (alreadyExists) return;

      state.list.push({ label: addedFont, value: addedFont });
    },
  },
});

export const { addFont } = fontsSlice.actions;

export default fontsSlice.reducer;
